<template>
  <div class="error-window bg-white d-flex align-items-center justify-content-center" v-if="control">

    <!-- Retorno da mensagem de sucesso -->
    <div class="text-center">
      <h4 class="display-1 text-danger mb-5">Ops...</h4>
      <p class="text-secondary" v-html="msg" />
    </div>

  </div>
</template>

<script>
export default {
  props: {
    msg: {
      type: String, 
      default: 'Mensagem enviada com sucesso.'
    }, 
    control: {
      type: Boolean, 
      default: false
    }
  }
}
</script>

<style scoped>  
  .error-window {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 3;
  }
</style>
